import React, { FC } from 'react';
import { Modal } from 'react-bootstrap';
import Button from '../Button';

interface Props {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    loading?: boolean;
}

const LogoutConfirmationModal: FC<Props> = ({ show, onHide, onConfirm, loading = false }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Logout</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-0" style={{ fontSize: '15px', color: '#334155' }}>
                    Are you sure you want to logout?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={loading} variant="primary" onClick={onHide}>
                    Cancel
                </Button>
                <Button loading={loading} disabled={loading} variant="danger" onClick={onConfirm}>
                    Logout
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LogoutConfirmationModal;
